import type { ShopifyConversionsSummary } from '@discovr/types';

export const SUMMARY_POLL_MS = 30_000;
export const SUMMARY_POLL_CAP_MS = 10 * 60_000;

export interface ShopifySetupProgress {
  connected: boolean;
  codes: boolean;
  visit: boolean;
  order: boolean;
}

export function shopifySetupProgress(s: ShopifyConversionsSummary): ShopifySetupProgress {
  const current = (s.counts.creator_current ?? 0) + (s.counts.campaign_current ?? 0);
  return {
    connected: s.connected && s.store_state === 'connected',
    codes: current > 0,
    visit: s.last_referral_visit_at != null || s.totals.clicks_directional > 0,
    order: s.totals.orders - (s.totals.test_orders ?? 0) > 0,
  };
}

/** Poll only while codes exist and no order has landed, for at most the cap. */
export function summaryPollInterval(
  s: ShopifyConversionsSummary | undefined,
  startedAt: number,
  now: number,
): number | false {
  if (!s || now - startedAt >= SUMMARY_POLL_CAP_MS) return false;
  const p = shopifySetupProgress(s);
  return p.connected && p.codes && !p.order ? SUMMARY_POLL_MS : false;
}
